
import * as offer from './offer';

export default {
    ...offer
};

